module.exports = __webpack_public_path__ + "static/media/popin-convo.9a64e9ea.svg";